<template>
  <v-list two-line>
    <v-list-item dense v-if="COLPARAMS[r]" v-for="(row, r) in INFO" :key="r">
      <v-list-item-content v-if="!COLPARAMS[r].is_hyperlink">
        <v-list-item-title>{{ COLPARAMS[r].title }}</v-list-item-title>
        <v-list-item-subtitle v-if="COLPARAMS[r].simptype === 'datetime' && !!row" class="xm-wrap-text">
          {{
            row.split('T')[0]
          }}
        </v-list-item-subtitle>
        <v-list-item-subtitle v-else class="gx-text-wrap">{{ row }}</v-list-item-subtitle>
      </v-list-item-content>
      <hyperlink-object ref="hyperlinkObject"
                        v-if="COLPARAMS[r].is_hyperlink"
                        :col-data="COLPARAMS[r]"
                        :info-object="INFO"></hyperlink-object>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import HyperlinkObject from './HyperlinkObject';
import { GeoJSON } from 'ol/format';
import store from '../../../store';

export default {
  name: 'FeatureInfo',
  components: { HyperlinkObject },

  methods: {
    /**
     * Send the click event through to the child component
     */
    pushClickEvent() {
      console.dir(this.$refs.hyperlinkObject);
      this.$refs.hyperlinkObject[0].handleGoToURL();
    },
  },

  beforeDestroy() {
    this.$MAP.getLayerByID('info-highlight').getSource().clear()
  },

  mounted () {
    const format = new GeoJSON();
    const gj = this.RESULTS[this.LAYER].features[this.FEATURE];
    let layer = this.$MAP.getLayerByID('info-highlight');
    layer.getSource().clear();

    let featureFromGeojson = format.readFeature(gj, {
      featureProjection: this.$MAP.getView().getProjection().getCode(),
      dataProjection: `EPSG:${this.$store.getters.GET_LAYERS[this.LAYER_ID].epsg}`
    });
    console.dir(featureFromGeojson)
    console.log(featureFromGeojson.getGeometry().getCoordinates())
    layer.getSource().addFeature(featureFromGeojson);
    console.dir(layer)
  },

  computed: {
    ...mapState('featureInfo', {
      RESULTS: 'results',
      LAYER: 'selectedLayer',
      FEATURE: 'selectedFeature',
    }),
    INFO() {
      return this.RESULTS[this.LAYER].features[this.FEATURE].properties;
    },
    LAYER_ID() {
      return this.RESULTS[this.LAYER].features[this.FEATURE].id.split('.')[0];
    },
    COLPARAMS() {
      const obj = {};
      this.$store.getters.GET_LAYERS[this.LAYER_ID].colparams.forEach((param) => {
        console.dir(param);
        obj[param.name] = param;
      });
      return obj;
    },
  },

  data() {
    return {};
  },
};
</script>

<style scoped>
.gx-text-wrap {
  height: auto !important;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
}
</style>
